import { ValidationResultModel } from "../../../models/ValidationResultModel";
import {
    QUESTIONNAIRE_CHANGED,
    NAVIGATION_NEXT_PAGE,
    NAVIGATION_PREVIOUS_PAGE,
    NAVIGATION_BRANCH_TO,
    VALIDATION_CLEAR,
    VALIDATION_SET_RESULT,
    VALIDATION_SET_RESULT_NEXT,
} from "../../actions";
import { ActionTypes } from "../../actions/types";
import { omit, isEmpty, pickBy, without } from "../../../utils/lodash";
import { getQuestionTypeByVariableName } from "../../../models/utilities/questionnaireUtilities";
import { newValidationQuestionTypes } from "../../../validation/validators";
import { QuestionnaireModel } from "../../../models/QuestionnaireModel";
import { getMentionsCount } from "./variablesUtilities";
import { VariablesState } from "../../../models/states/VariablesState";

export const validationSliceReducer = (
    state: ValidationResultModel,
    action: ActionTypes,
    questionnaire: QuestionnaireModel,
    variablesState: VariablesState,
): ValidationResultModel => {
    switch (action.type) {
        case QUESTIONNAIRE_CHANGED:
        case NAVIGATION_NEXT_PAGE:
        case NAVIGATION_PREVIOUS_PAGE:
        case NAVIGATION_BRANCH_TO:
            return { isValid: true, errorsByVariableName: {} };
        case VALIDATION_CLEAR: {
            const omitVariablesErrors = (variables: string[]): ValidationResultModel => {
                const errorsByVariableName = omit(state.errorsByVariableName, variables);
                if (!isEmpty(errorsByVariableName)) {
                    return { isValid: false, errorsByVariableName };
                }
                return { isValid: true, errorsByVariableName: {} };
            };
            if (action.keepSoftPromptError) {
                const variablesWithSoftPromptError = Object.keys(
                    pickBy(
                        state.errorsByVariableName,
                        (errors, variableName) =>
                            getMentionsCount(variablesState, variableName) === 0 &&
                            errors.every((error) => error.softPrompt),
                    ),
                );
                const allVariables = Object.keys(state.errorsByVariableName);
                return omitVariablesErrors(without(allVariables, ...variablesWithSoftPromptError));
            }
            if (!action.includeNewValidationResults) {
                const newValidationVariables = Object.keys(state.errorsByVariableName).filter(
                    (variableName) =>
                        !newValidationQuestionTypes().includes(
                            getQuestionTypeByVariableName(questionnaire, variableName),
                        ),
                );
                return omitVariablesErrors(newValidationVariables);
            }
            return { isValid: true, errorsByVariableName: {} };
        }
        case VALIDATION_SET_RESULT:
        case VALIDATION_SET_RESULT_NEXT:
            return {
                isValid: state.isValid && action.result.isValid,
                errorsByVariableName: {
                    ...state.errorsByVariableName,
                    ...action.result.errorsByVariableName,
                },
            };
        default:
            return state;
    }
};
